import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../../hooks/useToast';
import { useAppDispatch } from '../../../../hooks/useAppDispatcher.hook';
import { setAssistantMiniChatOpenAction } from '../../../../redux/Assistant/Assistant.slice';
import { RoutesConstant } from '../../../../constants/routes.constant';
import { AssistantAskOrigin } from '../../../../types/assistant.types';
import BallIcon from '../../../../components/Icons/Ball.icon';
import IconButtonComponent from '../../../../components/IconButton.component';
import CrossIcon from '../../../../components/Icons/Cross.icon';
import { hexToRgba } from '../../../../services/hex.service';

interface AssistantReadyToastProps {
  id: string;
  origin: AssistantAskOrigin;
}

const StyledToast = styled.div`
  display: grid;
  grid-template-columns: 42px auto 32px;
  gap: 10px;
  align-items: center;
  min-width: 260px;
  cursor: pointer;
`;

const StyledIcon = styled.div`
  display: flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: ${({ theme }) => hexToRgba(theme.colors.BLUE.B400, 0.1)};
  color: ${({ theme }) => theme.colors.BLUE.B400};
`;

const StyledInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.TITLE};
`;

const StyledLink = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.BLUE.B400};
  text-transform: uppercase;
`;

const AssistantReadyToast = ({ id, origin }: AssistantReadyToastProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { dismissToast } = useToast();

  const handleOpen = () => {
    if (origin === 'mini-chat') {
      dispatch(setAssistantMiniChatOpenAction(true));
      navigate(RoutesConstant.CANDIDATES_GROUPS.ALL);
    } else {
      navigate(RoutesConstant.ASSISTANT);
    }

    dismissToast(id);
  };

  return (
    <StyledToast onClick={handleOpen}>
      <StyledIcon>
        <BallIcon />
      </StyledIcon>
      <StyledInfo>
        <StyledTitle>{t('assistant.readyToast')}</StyledTitle>
        <StyledLink>
          {origin === 'mini-chat'
            ? t('assistant.readyOpenMiniChat')
            : t('assistant.readyOpenAssistant')}
        </StyledLink>
      </StyledInfo>
      <IconButtonComponent
        onClick={event => {
          event.stopPropagation();
          dismissToast(id);
        }}
      >
        <CrossIcon />
      </IconButtonComponent>
    </StyledToast>
  );
};

export default AssistantReadyToast;
